// Weighting-set helpers shared by the Screen tab and the Score builder.

// A saved / API weighting set -> an editable draft.
export const toDraft = (ws) => ({
  id: ws.id, name: ws.name, description: ws.description || '', score_method: ws.score_method || 'percentile',
  pillars: (ws.pillars || []).map((p) => ({ name: p.name, weight: p.weight, metrics: (p.metrics || []).map((m) => ({ ...m })) })),
});

// A draft -> the API payload.
export const draftPayload = (d) => ({
  name: d.name, description: d.description, score_method: d.score_method,
  pillars: d.pillars.map((p) => ({ name: p.name, weight: Number(p.weight), metrics: p.metrics.map((m) => ({
    statistic: m.statistic, period: m.period, start: m.period === 'custom' ? m.start : undefined,
    rolling: m.rolling || null, summary: m.summary || 'latest', weight: Number(m.weight), label: m.label || undefined,
  })) })),
});

// "Score by statistics": a one-pillar, equal-weight weighting over the chosen statistics,
// so the score is the average of their cohort percentiles (one statistic = its percentile).
export const statisticsWeighting = (specs) => ({
  name: specs.length === 1 ? 'Single statistic' : `${specs.length} statistics (equal weight)`,
  description: 'Score = equal-weighted cohort percentiles of the chosen statistics', score_method: 'percentile',
  pillars: [{ name: 'Statistics', weight: 1, metrics: specs.map((s) => ({
    statistic: s.statistic, period: s.period, start: s.period === 'custom' ? s.start : undefined,
    rolling: s.rolling || null, summary: s.summary || 'latest', weight: 1,
  })) }],
});
